var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-listing-table__container" },
    [
      _c(
        "CompassTable",
        {
          ref: "emailListingTable",
          staticClass: "email-listing-table",
          attrs: {
            size: "large",
            border: true,
            isCheckable: _vm.isCheckable,
            checkedRows: _vm.selectedEmailsId
          },
          on: { "update:checkedRows": _vm.handleCheckEmails }
        },
        [
          _c(
            "CompassTableBody",
            { ref: "emailTableBody" },
            [
              _vm.isEmpty
                ? _c("EmailListingTableEmpty", {
                    staticClass: "email-listing-table__empty",
                    attrs: { hasActiveFilters: _vm.hasActiveFilters },
                    on: { resetFilters: _vm.handleResetFilters }
                  })
                : _vm._l(_vm.sortedEmails, function(email) {
                    return _c("EmailListingTableRow", {
                      key: email.id,
                      ref: "email-row-" + email.id,
                      refInFor: true,
                      attrs: { columns: _vm.columns, email: email },
                      on: {
                        "update:readingStatus": _vm.updateReadingStatus,
                        "open:related": _vm.handleOpenRelated
                      },
                      nativeOn: {
                        click: function($event) {
                          return (function(event) {
                            return _vm.onClickRow(email, event)
                          })($event)
                        }
                      }
                    })
                  })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }